module.exports = __webpack_public_path__ + "static/media/logo.ed9d94cf.png";